/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  L2CustomGateway,
  L2CustomGatewayInterface,
} from "../../../../contracts/arbitrum/gateway/L2CustomGateway";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "l1Token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "DepositFinalized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "l1Address",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "l2Address",
        type: "address",
      },
    ],
    name: "TokenSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "TxToL1",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "l1Token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_l2ToL1Id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_exitNum",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "WithdrawalInitiated",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "l1ERC721",
        type: "address",
      },
    ],
    name: "calculateL2TokenAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "counterpartGateway",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "exitNum",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "finalizeInboundTransfer",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "getOutboundCalldata",
    outputs: [
      {
        internalType: "bytes",
        name: "outboundCalldata",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_l1Counterpart",
        type: "address",
      },
      {
        internalType: "address",
        name: "_router",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "l1ToL2Token",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_l1Token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "outboundTransfer",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_l1Token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "outboundTransfer",
    outputs: [
      {
        internalType: "bytes",
        name: "res",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "postUpgradeInit",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "l1Address",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "l2Address",
        type: "address[]",
      },
    ],
    name: "registerTokenFromL1",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "router",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b50611f16806100206000396000f3fe6080604052600436106100a75760003560e01c806395fcea781161006457806395fcea78146101b4578063a0c76a96146101cb578063a7e28d4814610208578063d2ce7d6514610245578063d4f5532f14610275578063f887ea401461029e576100a7565b8063015234ab146100ac5780632db09c1c146100d75780632e567b3614610102578063485cc9551461011e5780637b3a3c8b146101475780638a2dc01414610177575b600080fd5b3480156100b857600080fd5b506100c16102c9565b6040516100ce91906110e6565b60405180910390f35b3480156100e357600080fd5b506100ec6102cf565b6040516100f99190611142565b60405180910390f35b61011c6004803603810190610117919061122e565b6102f3565b005b34801561012a57600080fd5b50610145600480360381019061014091906112c8565b610437565b005b610161600480360381019061015c9190611308565b610445565b60405161016e9190611420565b60405180910390f35b34801561018357600080fd5b5061019e60048036038101906101999190611442565b610462565b6040516101ab9190611142565b60405180910390f35b3480156101c057600080fd5b506101c9610495565b005b3480156101d757600080fd5b506101f260048036038101906101ed919061159f565b610512565b6040516101ff9190611420565b60405180910390f35b34801561021457600080fd5b5061022f600480360381019061022a9190611442565b6105a8565b60405161023c9190611142565b60405180910390f35b61025f600480360381019061025a9190611636565b610611565b60405161026c9190611420565b60405180910390f35b34801561028157600080fd5b5061029c6004803603810190610297919061173b565b610860565b005b3480156102aa57600080fd5b506102b3610a92565b6040516102c09190611142565b60405180910390f35b60025481565b60008054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b61031c60008054906101000a900473ffffffffffffffffffffffffffffffffffffffff16610ab8565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614610389576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161038090611819565b60405180910390fd5b60006103958383610ae1565b91505060006103a3886105a8565b90506103b181878785610b02565b8573ffffffffffffffffffffffffffffffffffffffff168773ffffffffffffffffffffffffffffffffffffffff168973ffffffffffffffffffffffffffffffffffffffff167fc7f2e9c55c40a50fbc217dfc70cd39a222940dfa62145aa0ca49eb9535d4fcb28860405161042591906110e6565b60405180910390a45050505050505050565b6104418282610b77565b5050565b60606104578686866000808888610611565b905095945050505050565b60036020528060005260406000206000915054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b600061049f610bf4565b90508073ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff161461050f576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161050690611885565b60405180910390fd5b50565b6060632e567b3660e01b8686868661052c60025488610c25565b6040516024016105409594939291906118a5565b604051602081830303815290604052907bffffffffffffffffffffffffffffffffffffffffffffffffffffffff19166020820180517bffffffffffffffffffffffffffffffffffffffffffffffffffffffff8381831617835250505050905095945050505050565b6000600360008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff169050919050565b606060003414610656576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161064d9061194b565b60405180910390fd5b6000606061066333610c51565b1561067f576106728585610cab565b80925081935050506106ca565b33915084848080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f8201169050808301925050505050505090505b6000806106d68c6105a8565b90506106f78173ffffffffffffffffffffffffffffffffffffffff16610cc9565b610736576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161072d906119b7565b60405180910390fd5b8b73ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff1663c2eeeebd6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610798573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906107bc91906119ec565b73ffffffffffffffffffffffffffffffffffffffff1614610812576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161080990611a65565b60405180910390fd5b61081e81858c86610cec565b995061082d8c858d8d87610d68565b9150508060405160200161084191906110e6565b6040516020818303038152906040529350505050979650505050505050565b61088960008054906101000a900473ffffffffffffffffffffffffffffffffffffffff16610ab8565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff16146108f6576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016108ed90611819565b60405180910390fd5b60005b84849050811015610a8b5782828281811061091757610916611a85565b5b905060200201602081019061092c9190611442565b6003600087878581811061094357610942611a85565b5b90506020020160208101906109589190611442565b73ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055508282828181106109e3576109e2611a85565b5b90506020020160208101906109f89190611442565b73ffffffffffffffffffffffffffffffffffffffff16858583818110610a2157610a20611a85565b5b9050602002016020810190610a369190611442565b73ffffffffffffffffffffffffffffffffffffffff167f0dd664a155dd89526bb019e22b00291bb7ca9d07ba3ec4a1a76b410da9797ceb60405160405180910390a38080610a8390611ae3565b9150506108f9565b5050505050565b600160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b600073111100000000000000000000000000000000111182610ada9190611b2b565b9050919050565b6060808383810190610af39190611b73565b80925081935050509250929050565b8373ffffffffffffffffffffffffffffffffffffffff1663cb6eb3f48484846040518463ffffffff1660e01b8152600401610b3f93929190611beb565b600060405180830381600087803b158015610b5957600080fd5b505af1158015610b6d573d6000803e3d6000fd5b5050505050505050565b610b818282610e03565b600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff1603610bf0576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610be790611c75565b60405180910390fd5b5050565b6000807fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d610360001b9050805491505090565b60608282604051602001610c3a929190611c95565b604051602081830303815290604052905092915050565b6000600160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff16149050919050565b600060608383810190610cbe9190611d03565b915091509250929050565b6000808273ffffffffffffffffffffffffffffffffffffffff163b119050919050565b60008473ffffffffffffffffffffffffffffffffffffffff1663720f5a9c8585856040518463ffffffff1660e01b8152600401610d2b93929190611beb565b600060405180830381600087803b158015610d4557600080fd5b505af1158015610d59573d6000803e3d6000fd5b50505050829050949350505050565b60008060025490506000610d898786610d848b8b8b8b8b610512565b610f86565b9050808673ffffffffffffffffffffffffffffffffffffffff168873ffffffffffffffffffffffffffffffffffffffff167f3073a74ecb728d10be779fe19a74a1428e20468f5b4d167bf9c73d9067847d738b868a604051610ded93929190611d5f565b60405180910390a4809250505095945050505050565b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff1603610e72576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610e6990611de2565b60405180910390fd5b600073ffffffffffffffffffffffffffffffffffffffff1660008054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1614610f01576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610ef890611e4e565b60405180910390fd5b816000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555080600160006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055505050565b600060026000815480929190610f9b90611ae3565b9190505550610fcd60008560008054906101000a900473ffffffffffffffffffffffffffffffffffffffff1685610fd6565b90509392505050565b600080606473ffffffffffffffffffffffffffffffffffffffff1663928c169a8786866040518463ffffffff1660e01b8152600401611016929190611e6e565b60206040518083038185885af1158015611034573d6000803e3d6000fd5b50505050506040513d601f19601f820116820180604052508101906110599190611eb3565b9050808473ffffffffffffffffffffffffffffffffffffffff168673ffffffffffffffffffffffffffffffffffffffff167f2b986d32a0536b7e19baa48ab949fec7b903b7fad7730820b20632d100cc3a68866040516110b99190611420565b60405180910390a480915050949350505050565b6000819050919050565b6110e0816110cd565b82525050565b60006020820190506110fb60008301846110d7565b92915050565b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b600061112c82611101565b9050919050565b61113c81611121565b82525050565b60006020820190506111576000830184611133565b92915050565b6000604051905090565b600080fd5b600080fd5b61117a81611121565b811461118557600080fd5b50565b60008135905061119781611171565b92915050565b6111a6816110cd565b81146111b157600080fd5b50565b6000813590506111c38161119d565b92915050565b600080fd5b600080fd5b600080fd5b60008083601f8401126111ee576111ed6111c9565b5b8235905067ffffffffffffffff81111561120b5761120a6111ce565b5b602083019150836001820283011115611227576112266111d3565b5b9250929050565b60008060008060008060a0878903121561124b5761124a611167565b5b600061125989828a01611188565b965050602061126a89828a01611188565b955050604061127b89828a01611188565b945050606061128c89828a016111b4565b935050608087013567ffffffffffffffff8111156112ad576112ac61116c565b5b6112b989828a016111d8565b92509250509295509295509295565b600080604083850312156112df576112de611167565b5b60006112ed85828601611188565b92505060206112fe85828601611188565b9150509250929050565b60008060008060006080868803121561132457611323611167565b5b600061133288828901611188565b955050602061134388828901611188565b9450506040611354888289016111b4565b935050606086013567ffffffffffffffff8111156113755761137461116c565b5b611381888289016111d8565b92509250509295509295909350565b600081519050919050565b600082825260208201905092915050565b60005b838110156113ca5780820151818401526020810190506113af565b60008484015250505050565b6000601f19601f8301169050919050565b60006113f282611390565b6113fc818561139b565b935061140c8185602086016113ac565b611415816113d6565b840191505092915050565b6000602082019050818103600083015261143a81846113e7565b905092915050565b60006020828403121561145857611457611167565b5b600061146684828501611188565b91505092915050565b600080fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b6114ac826113d6565b810181811067ffffffffffffffff821117156114cb576114ca611474565b5b80604052505050565b60006114de61115d565b90506114ea82826114a3565b919050565b600067ffffffffffffffff82111561150a57611509611474565b5b611513826113d6565b9050602081019050919050565b82818337600083830152505050565b600061154261153d846114ef565b6114d4565b90508281526020810184848401111561155e5761155d61146f565b5b611569848285611520565b509392505050565b600082601f830112611586576115856111c9565b5b813561159684826020860161152f565b91505092915050565b600080600080600060a086880312156115bb576115ba611167565b5b60006115c988828901611188565b95505060206115da88828901611188565b94505060406115eb88828901611188565b93505060606115fc888289016111b4565b925050608086013567ffffffffffffffff81111561161d5761161c61116c565b5b61162988828901611571565b9150509295509295909350565b600080600080600080600060c0888a03121561165557611654611167565b5b60006116638a828b01611188565b97505060206116748a828b01611188565b96505060406116858a828b016111b4565b95505060606116968a828b016111b4565b94505060806116a78a828b016111b4565b93505060a088013567ffffffffffffffff8111156116c8576116c761116c565b5b6116d48a828b016111d8565b925092505092959891949750929550565b60008083601f8401126116fb576116fa6111c9565b5b8235905067ffffffffffffffff811115611718576117176111ce565b5b602083019150836020820283011115611734576117336111d3565b5b9250929050565b6000806000806040858703121561175557611754611167565b5b600085013567ffffffffffffffff8111156117735761177261116c565b5b61177f878288016116e5565b9450945050602085013567ffffffffffffffff8111156117a2576117a161116c565b5b6117ae878288016116e5565b925092505092959194509250565b600082825260208201905092915050565b7f4f4e4c595f434f554e544552504152545f474154455741590000000000000000600082015250565b60006118036018836117bc565b915061180e826117cd565b602082019050919050565b60006020820190508181036000830152611832816117f6565b9050919050565b7f4e4f545f46524f4d5f41444d494e000000000000000000000000000000000000600082015250565b600061186f600e836117bc565b915061187a82611839565b602082019050919050565b6000602082019050818103600083015261189e81611862565b9050919050565b600060a0820190506118ba6000830188611133565b6118c76020830187611133565b6118d46040830186611133565b6118e160608301856110d7565b81810360808301526118f381846113e7565b90509695505050505050565b7f4e4f5f56414c5545000000000000000000000000000000000000000000000000600082015250565b60006119356008836117bc565b9150611940826118ff565b602082019050919050565b6000602082019050818103600083015261196481611928565b9050919050565b7f544f4b454e5f4e4f545f4445504c4f5945440000000000000000000000000000600082015250565b60006119a16012836117bc565b91506119ac8261196b565b602082019050919050565b600060208201905081810360008301526119d081611994565b9050919050565b6000815190506119e681611171565b92915050565b600060208284031215611a0257611a01611167565b5b6000611a10848285016119d7565b91505092915050565b7f4e4f545f45585045435445445f4c315f544f4b454e0000000000000000000000600082015250565b6000611a4f6015836117bc565b9150611a5a82611a19565b602082019050919050565b60006020820190508181036000830152611a7e81611a42565b9050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b6000611aee826110cd565b91507fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff8203611b2057611b1f611ab4565b5b600182019050919050565b6000611b3682611101565b9150611b4183611101565b9250828201905073ffffffffffffffffffffffffffffffffffffffff811115611b6d57611b6c611ab4565b5b92915050565b60008060408385031215611b8a57611b89611167565b5b600083013567ffffffffffffffff811115611ba857611ba761116c565b5b611bb485828601611571565b925050602083013567ffffffffffffffff811115611bd557611bd461116c565b5b611be185828601611571565b9150509250929050565b6000606082019050611c006000830186611133565b611c0d60208301856110d7565b8181036040830152611c1f81846113e7565b9050949350505050565b7f4241445f524f5554455200000000000000000000000000000000000000000000600082015250565b6000611c5f600a836117bc565b9150611c6a82611c29565b602082019050919050565b60006020820190508181036000830152611c8e81611c52565b9050919050565b6000604082019050611caa60008301856110d7565b8181036020830152611cbc81846113e7565b90509392505050565b6000611cd082611101565b9050919050565b611ce081611cc5565b8114611ceb57600080fd5b50565b600081359050611cfd81611cd7565b92915050565b60008060408385031215611d1a57611d19611167565b5b6000611d2885828601611cee565b925050602083013567ffffffffffffffff811115611d4957611d4861116c565b5b611d5585828601611571565b9150509250929050565b6000606082019050611d746000830186611133565b611d8160208301856110d7565b611d8e60408301846110d7565b949350505050565b7f494e56414c49445f434f554e5445525041525400000000000000000000000000600082015250565b6000611dcc6013836117bc565b9150611dd782611d96565b602082019050919050565b60006020820190508181036000830152611dfb81611dbf565b9050919050565b7f414c52454144595f494e49540000000000000000000000000000000000000000600082015250565b6000611e38600c836117bc565b9150611e4382611e02565b602082019050919050565b60006020820190508181036000830152611e6781611e2b565b9050919050565b6000604082019050611e836000830185611133565b8181036020830152611e9581846113e7565b90509392505050565b600081519050611ead8161119d565b92915050565b600060208284031215611ec957611ec8611167565b5b6000611ed784828501611e9e565b9150509291505056fea2646970667358221220d6e6ddebf0f384c1ab9cad9305e6ee33fe1c25a9ebb37a3972c970376f02611964736f6c63430008110033";

type L2CustomGatewayConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: L2CustomGatewayConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class L2CustomGateway__factory extends ContractFactory {
  constructor(...args: L2CustomGatewayConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<L2CustomGateway> {
    return super.deploy(overrides || {}) as Promise<L2CustomGateway>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): L2CustomGateway {
    return super.attach(address) as L2CustomGateway;
  }
  override connect(signer: Signer): L2CustomGateway__factory {
    return super.connect(signer) as L2CustomGateway__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): L2CustomGatewayInterface {
    return new utils.Interface(_abi) as L2CustomGatewayInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): L2CustomGateway {
    return new Contract(address, _abi, signerOrProvider) as L2CustomGateway;
  }
}
